<template v-if="actorInfo">
    <dl class="aeg-description-list">
        <template v-if="emails">
            <dt class="aeg-description-list__term">Email:</dt>
            <dd class="aeg-description-list__description"> {{ emails }} - <Button variant="link" @click.prevent="editActorEmails">aanpassen</Button></dd>
            <aeg-edit-actor-mails :actor="actorInfo" v-model:visible="editActorModalVisible" @on-save="updateActorEmails" />
        </template>
        <template v-if="actorInfo.service && !isCitizen">
            <dt class="aeg-description-list__term">{{ actorInfo.service }}-saldo:</dt>
            <dd class="aeg-description-list__description">€ {{ formatAmount(actorInfo.amount) }}</dd>
        </template>
    </dl>

    <template v-if="invoiceSettings && invoiceSettings.length > 0">
        <h4 class="heading-4">Factuurinstellingen</h4>
        <template v-for="setting in invoiceSettings" :key="setting.invoiceSettingsId">
            <dl class="aeg-description-list">
                <dt class="aeg-description-list__term">InvoiceSettingId:</dt>
                <dd class="aeg-description-list__description">{{ setting.invoiceSettingsId }}</dd>

                <template v-if="setting.invoiceReference">
                    <dt class="aeg-description-list__term">Eigen referentie:</dt>
                    <dd class="aeg-description-list__description">{{ setting.invoiceReference }}</dd>
                </template>

                <template v-if="setting.forTheAttentionOf">
                    <dt class="aeg-description-list__term">T.a.v.:</dt>
                    <dd class="aeg-description-list__description">{{ setting.forTheAttentionOf }}</dd>
                </template>

                <dt class="aeg-description-list__term"></dt>
                <dd class="aeg-description-list__description">
                    <Button variant="link" @click.prevent="editSettings(setting)">aanpassen</Button>
                </dd>
            </dl>
            <aeg-edit-invoice-settings
                :invoice-settings="setting"
                v-model:visible="editSettingsModalVisible"
                @on-save="handleInvoiceSettingsSaved"
            />
        </template>
    </template>
</template>
<template v-else>
    Niet actief
</template>
